import { useQuery } from '@tanstack/react-query'
import type { Portfolio } from '@/types/api'
import { apiClient } from '@/lib/api-client'

/**
 * Query key factory for portfolio queries
 */
export const portfolioKeys = {
  all: ['portfolio'] as const,
  current: () => [...portfolioKeys.all, 'current'] as const,
}

/**
 * Hook to fetch the current portfolio
 * 
 * Features:
 * - 30 second stale time for portfolio data
 * - Automatic background refetching
 * - Error handling with ApiError
 * 
 * @returns Query result with Portfolio data
 */
export function usePortfolio() {
  return useQuery<Portfolio>({
    queryKey: portfolioKeys.current(),
    queryFn: () => apiClient.getPortfolio(),
    staleTime: 1000 * 30, // 30 seconds
    gcTime: 1000 * 60 * 5, // 5 minutes
  })
}
